export const emptySurveyAnswerData = {
    preset: [{ text: "", nanoid: "" }],
    custom: [{ text: "", nanoid: "" }],
};

export const emptyCustomAnswerData = [{ text: "", nanoid: "", saved: false }];

export const emptyPresetAnswerData = [{ text: "", nanoid: "", saved: false }];

export const emptySurveyQuestionResponse = {
    text: "",
    position: 1,
};

export const RESPONSE_OPTION_MAX_LENGTH = 255;

export const emptySurveyQuestionData = {
    answer_type: "multiple",
    description: "",
    is_allow_custom: false,
    is_random_order: false,
    is_view_all: true,
    position: 1,
    question_type: "freeform",
    text: "",
    preset_answers: [],
    is_demographic_question: false,
    contains_pii: false,
    answer_limit: 150,
    media_url: ''
};

// Frontend implements defensive validation for user_limit: the backend value
// is only treated as valid if it is 1 or higher. Otherwise we fall back to
// MIN_SEAT_COUNT (1).
export const MIN_SEAT_COUNT = 1;

/**
 * Returns userLimit if valid (number >= 1), otherwise MIN_SEAT_COUNT.
 * @param {number|null|undefined} userLimit - The user_limit from backend
 * @returns {number} A valid user_limit (minimum 1)
 */
export const getValidUserLimit = (userLimit) => {
    if (typeof userLimit === 'number' && userLimit >= MIN_SEAT_COUNT) {
        return userLimit;
    }
    return MIN_SEAT_COUNT;
};

export const SUBSCRIPTION_NAMES = {
    FREE_INDIVIDUAL: "Free Plan (Individual)",
};

// Managed accounts have no stripe_subscription row, so the organisation
// endpoint's subscription_name stays "Free Plan (Individual)" for them and the
// store-computed subscriptionDetails must win.
export const resolvePlanLabel = (isManaged, subscriptionDetails, orgSubscriptionName) => (
    (isManaged && subscriptionDetails) || orgSubscriptionName || subscriptionDetails || SUBSCRIPTION_NAMES.FREE_INDIVIDUAL
);
